// (function() {
//     'use strict';

//     angular.module("imApp").factory("calculationSeasonyearService", ['$ihttp', function ($ihttp) {
//         let service = {
//             // recalculateGrid: function (list) {
//             //     return $ihttp.post({
//             //         method: 2640,
//             //         parameters: list
//             //     });
//             // }
//         };

//         return service;
//     }]);
// })();
